import { Answer } from '@/gql/graphql';
import { useDebounce } from '@/hooks/use-debounce.hook';
import { useTailoringStore } from '@/store/pre-tailoring.store';
import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import { answerQuestion } from '../pages/pre-tailoring/pre-tailoring.requests';

export const useAnswerQuestion = (productId?: string) => {
  const { setUpdatedAt } = useTailoringStore((state) => ({
    setUpdatedAt: state.setUpdatedAt,
  }));

  const [storedAnswers, setStoredAnswers] = useState<Record<string, string>>({});
  const [answerQuestionMutation, { loading }] = useMutation(answerQuestion);

  useEffect(() => {
    if (Object.entries(storedAnswers).length === 0) return;
    debouncedAnswerQuestion();
  }, [storedAnswers]);

  const debouncedAnswerQuestion = useDebounce(async () => {
    for (const questionId in storedAnswers) {
      const answer = storedAnswers[questionId] as Answer;
      await answerQuestionMutation({
        variables: {
          answerPretailoringInput: {
            questionId,
            productId: productId || '',
            answer,
          },
        },
      });
    }
    setStoredAnswers({});
    setUpdatedAt(productId || '', new Date());
  });

  const answerDebouncedQuestion = async (questionId: string, value: string) => {
    const answer = value.toUpperCase() as Answer;
    await setStoredAnswers({
      ...storedAnswers,
      [questionId]: answer,
    });
  };

  const answerSingleQuestion = async (questionId: string, answer: Answer) => {
    await answerQuestionMutation({
      variables: {
        answerPretailoringInput: {
          questionId,
          productId: productId || '',
          answer,
        },
      },
      onCompleted: () => {
        setUpdatedAt(productId || '', new Date());
      },
    });
  };

  return { answerDebouncedQuestion, answerSingleQuestion, answerLoading: loading };
};
